import { OrganizationType } from '../../../../models/enums/OrganizationType';
import { getOptionsFromEnum } from '../../../../utils/getOptionsFromEnum';

export const organizationTypeOptions = getOptionsFromEnum(
  OrganizationType,
  'organization-type',
);
